export const day = {
  mon: {
    full: 'Понедельник',
    short: 'Пн'
  },

  tue: {
    full: 'Вторник',
    short: 'Вт'
  },

  wed: {
    full: 'Среда',
    short: 'Ср'
  },

  thu: {
    full: 'Четверг',
    short: 'Чт'
  },

  fri: {
    full: 'Пятница',
    short: 'Пт'
  },

  sat: {
    full: 'Суббота',
    short: 'Сб'
  },

  sun: {
    full: 'Воскресенье',
    short: 'Вс'
  }
};
